import React from 'react';
import { Container, Typography, Box, Grid } from '@mui/material';
import { Psychology, Timeline, TrendingUp } from '@mui/icons-material';
import PremiumCard from '../components/ui/PremiumCard';
import PredictiveInsightsCard from '../components/Dashboard/cards/PredictiveInsightsCard';
import { useStoreStats } from '../hooks/useApiWithStore';

/**
 * Página de Análisis Predictivo
 * Predicciones e insights que Tiendanube no ofrece
 */
export default function PredictiveAnalytics() {
  const { data: statsData, isLoading, error } = useStoreStats();

  if (isLoading) {
    return (
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Typography>Cargando análisis predictivo...</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box mb={4}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Análisis Predictivo
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Predicciones inteligentes y análisis de tendencias para tu negocio
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} lg={8}>
          <PredictiveInsightsCard statsData={statsData} salesData={[]} />
        </Grid>
        
        <Grid item xs={12} lg={4}>
          <PremiumCard
            title="Próximamente"
            subtitle="IA Avanzada"
            icon={<Psychology />}
            color="info"
            exclusive
          >
            <Typography variant="body2" color="text.secondary">
              • Predicción de demanda
              • Análisis de estacionalidad
              • Detección de anomalías
              • Recomendaciones automáticas
            </Typography>
          </PremiumCard>
        </Grid>
      </Grid>
    </Container>
  );
}
